<template>
<div class="detail-list-item">
  <div>
    <strong>{{ title }}</strong>
    <span v-if="asside"> (<em>{{ asside }}</em>)</span>
    <PartOfFortune v-if="showFortune" size="0.8em" style="margin-left: 0.4em"/>
    <PartOfSpirit v-if="showIndex" size="0.8em" style="margin-left: 0.4em"/>
  </div>
  <div v-if="figureName">{{ figureName }}</div>
  <div v-if="alt">{{ alt }}</div>
</div>
</template>

<script>
import Names from '../utils/names'
import PartOfFortune from './PartOfFortune'
import PartOfSpirit from './PartOfSpirit'

/**
 * This component is a little overloaded so here's some docs for future me:
 * title: Left bold side of the item
 * figureIndex: Position in the chart of the figure to show the name of (on the right)
 * secondFigureIndex, thirdFigureIndex: Used exclusively to show the triplicities
 * alt: If alt is supplied, then figureIndex should not be. Alt shows on the right where the figure name would be. Used by the Sum of the chart (for now).
 */
export default {
  name: 'DetailListItem',
  components: {
    PartOfFortune,
    PartOfSpirit
  },
  props: {
    title: String,
    figureIndex: Number,
    secondFigureIndex: Number,
    thirdFigureIndex: Number,
    asside: String,
    alt: String,
    showFortune: {
      type: Boolean,
      default: false
    },
    showIndex: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    figureName() {
      if (this.figureIndex) {
        const fig = this.$store.getters.getFigureById(this.figureIndex)

        if (this.secondFigureIndex && this.thirdFigureIndex) {
          const fig2 = this.$store.getters.getFigureById(this.secondFigureIndex)
          const fig3 = this.$store.getters.getFigureById(this.thirdFigureIndex)

          return Names.getNameForFigure(fig) + ' > ' +
                 Names.getNameForFigure(fig2) + ' > ' +
                 Names.getNameForFigure(fig3)
        }

        return Names.getNameForFigure(fig)
      } else {
        return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.detail-list-item {
  display: flex;
  justify-content: space-between;
}
</style>
